export const DEFAULT_LANGUAGE = "en";
export const MAX_WIDTH_PX = 892;
export const GUTTER = 48;
export const CONTACT_US_URL = "hugfimi@hugfimi.is"